var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-details"},[_c('div',{staticClass:"index-title"},[_vm._v(_vm._s(_vm.detailsConten.title))]),_vm._v(" "),_c('div',{staticClass:"index-date"},[_vm._v(_vm._s(_vm.detailsConten.create_time))]),_vm._v(" "),_c('div',{staticClass:"index-con",domProps:{"innerHTML":_vm._s(_vm.detailsConten.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7794ee98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/singlePage.vue
// module id = null
// module chunks = 